module.exports = __webpack_public_path__ + "img/usp-logo-transp.462b6d02.png";